const nav = document.querySelector('nav'); 
const navigationTrigger = document.querySelector('.navigation-trigger'); 
const navigationClose = document.querySelector('.navigation-close'); 

const triggerEvent = function(e){
    e.preventDefault();
    let dummy = nav.classList.contains('active')
        ? nav.classList.remove('active')
        : nav.classList.add('active');
}

document.addEventListener('DOMContentLoaded',function(e){
    navigationTrigger.addEventListener('click', triggerEvent);
    navigationClose.addEventListener('click', triggerEvent);
});